###
  CRUD Segment widget
###

class INTENT.widgets.CrudSegment

  @ATTR_NAME: "data-widget-crud-segments"
  @ATTR_ID: "#{@ATTR_NAME}-id"
  @ATTR_JSON: "#{@ATTR_NAME}-json"
  @ATTR_VALUES: "#{@ATTR_NAME}-values"

  @ATTR_LOADING_STATE: "#{@ATTR_NAME}-loading"

  @ATTR_ADVERTISER_ID: "#{@ATTR_NAME}-advertiser-id"

  @ATTR_MODE: "#{@ATTR_NAME}-mode"
  @ATTR_MODE_SWITCHER: "#{@ATTR_MODE}-switcher"

  @ATTR_TERM: "#{@ATTR_NAME}-terms"
  @ATTR_TERM_ID: "#{@ATTR_TERM}-id"
  @ATTR_TERMS_ADD: "#{@ATTR_TERM}-add"
  @ATTR_TERMS_REMOVE: "#{@ATTR_TERM}-remove"
  @ATTR_TERMS_VALUES: "#{@ATTR_TERM}-values"
  @ATTR_TERMS_TYPE: "#{@ATTR_TERM}-type"

  @ATTR_TERMS_CONTAINER: "#{@ATTR_TERM}-container"

  @CLASS_ERROR: "error-input-field"

  constructor: (@el) ->
    @s = @.constructor

    @segment_id = parseInt @el.attr @s.ATTR_ID

    @mode_switcher = @el.find "[#{@s.ATTR_MODE_SWITCHER}]"
    @mode_pages_collection = @el.find "[#{@s.ATTR_MODE}]"

    @terms_add = @el.find "[#{@s.ATTR_TERMS_ADD}]"
    @terms_container = @el.find "[#{@s.ATTR_TERMS_CONTAINER}]"
    @terms_container.on "click", "[#{@s.ATTR_TERMS_REMOVE}]", @remove_item

    @terms_add.on "click", @add_item

    @terms_add.hide()

    @mode_switcher.on "change", =>
      @update_mode_page()

    @form = @el.find "form"

    @update_mode_page()

    $(document).on "keyup", '[name$="[days]"]', (e) =>
      el = e.currentTarget
      if parseInt(el.value) > 30
        e.currentTarget.value = 30

    @el.on 'change', "[#{@s.ATTR_TERMS_TYPE}]", (e) =>
      self = $ e.currentTarget
      parent_tr = self.parents('tr')
      container = parent_tr.find("[#{@s.ATTR_TERMS_VALUES}]")
      id = parseInt parent_tr.attr @s.ATTR_TERM_ID
      tpl = INTENT.templates.CrudSegment.get_values_control @, id, self.val(), @get_json(), @get_origin_values()
      container.html tpl
      @displaying_delete()
      init_numbers_fields()
      init_select2()

  get_json: =>
    unless @json
      json = @el.attr @s.ATTR_JSON
      @json = jQuery.parseJSON json

    return @json

  get_advertiser_id: =>
    id = @el.attr @s.ATTR_ADVERTISER_ID
    parseInt id

  update_mode_page: =>
    @mode_pages_collection.hide()
    current = @mode_switcher.val()
    page = @mode_pages_collection.filter "[#{@s.ATTR_MODE}='#{current}']"
    inputs_others = @mode_pages_collection.filter("[#{@s.ATTR_MODE}][#{@s.ATTR_MODE}!='#{current}']").find("input,select")
    inputs_others.attr('disabled', 'disabled')
    page.find('input,select').removeAttr('disabled')
    page.show()

    if current == 'standard'
      # init all
      INTENT.utils.Forms.disable_submit_buttons()
      @el.attr @s.ATTR_LOADING_STATE, true
      @load_variants().done (list) =>
        @init_exist()
        @terms_add.show()
        @el.removeAttr @s.ATTR_LOADING_STATE
        INTENT.utils.Forms.enable_submit_buttons()
        @displaying_delete()
    else
      INTENT.utils.Forms.enable_submit_buttons()

  get_origin_values: =>
    unless @origin_values
      origin_values = @el.attr @s.ATTR_VALUES
      @origin_values = jQuery.parseJSON origin_values

    return @origin_values

  get_last_id: =>
    unless @terms_container.find('tr').length
      return 0

    last_id = parseInt @terms_container.find('tr:last').attr @s.ATTR_TERM_ID
    return last_id + 1

  init_exist: =>
    @terms_container.empty()
    exists_terms = @get_origin_values()
    if exists_terms.length > 0
      for ex_index, ex_term of exists_terms
        id = @get_last_id()
        item = INTENT.templates.CrudSegment.get_term @, id, @get_json(), ex_term
        @terms_container.append item
    else
      @add_item()

    init_select2()

  displaying_delete: =>
    tr_collection = @terms_container.find "[#{@s.ATTR_TERMS_REMOVE}]"
    tr_count = tr_collection.length

    if tr_count > 1
      tr_collection.fadeIn 'fast'
    else
      tr_collection.fadeOut 'fast'

  load_variants: =>
    dfd = $.Deferred()

    params = {
      url: '/ajax/get_segment_partial',
      type: 'POST',
      dataType: 'json',
      data: { 'advertiser_id': @get_advertiser_id(), 'segment_id': @segment_id }
    }

    $.ajax(params).done (xhr) =>
      @variants = xhr
      dfd.resolve @variants

    return dfd.promise()

  get_variants: (type) =>
    @variants[type] || []

  remove_item: (e) =>
    self = $ e.currentTarget
    self.parents("tr").remove()
    @displaying_delete()
    return false

  add_item: =>
    id = @get_last_id()
    item = INTENT.templates.CrudSegment.get_term @, id, @get_json()
    @terms_container.append item
    @displaying_delete()
    init_select2()
    init_numbers_fields()
    return false
